
export const createDropdownFilter = ( el: HTMLElement ) => {
	const DropdownFilterObject = {
		filter:  el,
		filters: el.querySelectorAll( '.dropdown-filter__list input' ) as NodeListOf<HTMLInputElement>,
		button:  el.querySelector( '.dropdown-filter__button' ) as HTMLElement,
		counter: el.querySelector( '.dropdown-filter__button-counter' ) as HTMLElement,
		name:    el.dataset.dropdownFilter as string,
		overlay: el.querySelector( '.dropdown-filter__overlay' ) as HTMLElement,
		isOpen:  false as boolean,

		_init(): void {
			this._bindClass();
			this._bindEvents();
		},

		_bindClass(): void {
			this.closeDropdown  = this.closeDropdown.bind(this);
			this.openDropdown   = this.openDropdown.bind(this);
			this.toggleFilter   = this.toggleFilter.bind(this);
			this.updateCounter  = this.updateCounter.bind(this);
		},

		_bindEvents(): void {
			this.overlay?.addEventListener( 'click', this.closeDropdown );
			this.button?.addEventListener( 'click', this.openDropdown );
			this.filters.forEach( filter => {
				filter.addEventListener( 'change', this.toggleFilter );
			});
		},

		closeDropdown(): void {
			this.filter?.classList.remove('dropdown-filter--open');
		},

		openDropdown( event: Event ): void {
			event.preventDefault();

			// Close other dropdown filters.
			document.querySelectorAll( '.dropdown-filter' ).forEach( (filter) => {
				if ( filter !== this.filter ) {
					filter.classList.remove( 'dropdown-filter--open' );
				}
			} );

			this.filter?.classList.toggle( 'dropdown-filter--open' );
		},

		toggleFilter(event: Event): void {
			const params = new URLSearchParams();
			const filters: Record<string, string[]> = {};

			document
				.querySelectorAll<HTMLInputElement>('.dropdown-filter__list input:checked')
				.forEach((input) => {
					params.append(input.name, input.value);

					if (!filters[input.name]) {
						filters[input.name] = [];
					}

					filters[input.name].push(input.value);
				});

			const query = params.toString();

			window.history.replaceState(
				{},
				'',
				query
					? `${window.location.pathname}?${query}`
					: window.location.pathname
			);

			dispatchChangeFilters(filters);

			this.updateCounter( filters[this.name]?.length ?? 0 )
		},

		updateCounter( counter: number ): void {
			// @ts-ignore
			this.counter?.innerHTML = counter;
			this.counter.style.display = 0 === counter
				? 'none'
				: 'inline-block';
		}
	}

	DropdownFilterObject._init();
	return DropdownFilterObject;
};

export const dispatchChangeFilters = ( detail: any ): void => {
	const event = new CustomEvent(
		'wvnderlab:filters:change',
		{
			detail: detail
		}
	);

	window.dispatchEvent( event );
}

export const onChangeFilters = ( callback: any ): void => {
	window.addEventListener( 'wvnderlab:filters:change', callback );
}
